import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import moment from 'moment';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-provider-users-list',
    templateUrl: './provider-users-list.component.html',
    styleUrls: [
        './provider-users-list.component.scss',
    ],
    standalone: false
})
export class ProviderUsersListComponent implements OnInit {
  provider: any;
  dispatchers: [];
  selectedDispatcher: any;
  first: number = 0;
  last: number;
  rows:number = 10;
  totalRecords: number;

  tableConfig = {
    columns: {
      last_name: {
        title: 'Last name',
      },
      first_name: {
        title: 'First name',
      },
      email: {
        title: 'Email',
      },
      confirmed_at: {
        title: 'Confirmed?',
      },
      active: {
        title: 'Active?',
      },
      created_at: {
        title: 'Created On',
      }
    },
    actions: {
      add: false,
      edit: false,
      delete: false
    },
    pager: {
      perPage: 10
    },
    noDataMessage: ''
  };

  keys = Object.keys(this.tableConfig.columns);
  placeholders = {
    last_name: 'Last name',
    first_name: 'First name',
    email: 'Email',
    confirmed_at: 'Confirmed?',
    active: 'Active?',
    created_at: 'Created On'
  };

  constructor(protected http: HttpClient, private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.data.subscribe((data) => {
      this.provider = data.provider.data;
      const url = `providers/${this.provider.id}/dispatchers?per_page=100`;
      this.http.get(`${environment.apiurl}/${url}`, { observe: 'response' }).subscribe((response: any) => {
        this.totalRecords = response.body.meta['x-total-count'];
        this.dispatchers = this.formatDispatcherData(response.body.data);
      });
    });
  }

  formatDispatcherData = (dispatchers) => {
    dispatchers.forEach(dispatcher => {
      dispatcher['active'] = !!dispatcher['active'] ? 'Yes' : 'No';
      dispatcher['confirmed_at'] = !!dispatcher['confirmed_at'] ? 'Yes' : 'No';
      dispatcher['created_at'] =  moment(dispatcher['created_at']).format('LL h:mm A');
    });
    return dispatchers;
  }

  onRowSelect(event) {
    this.router.navigate(['/users', event.data.id]);
  }
}
